import styled from 'styled-components';
import { isObject } from 'styled-system';
import { boxSpacer } from '../space';
import { mapScalesFn } from '../scales';

var columnTemplate = function columnTemplate(colsNum) {
  return {
    gridTemplateColumns: "repeat(".concat(colsNum, ", minmax(0, 1fr))")
  };
};

var columns = function columns(_ref) {
  var cols = _ref.cols,
      theme = _ref.theme;
  return !isObject(cols) ? columnTemplate(cols) : mapScalesFn(theme.breakpoints, columnTemplate, cols);
};

var row = function row() {
  return {
    maxWidth: '100%',
    width: '100%',
    display: 'grid'
  };
};

var gridColumnGap = function gridColumnGap(val) {
  return {
    gridColumnGap: val
  };
};

var gridRowGap = function gridRowGap(val) {
  return {
    gridRowGap: val
  };
};

var gutterX = function gutterX(_ref2) {
  var theme = _ref2.theme,
      _ref2$columnGap = _ref2.columnGap,
      columnGap = _ref2$columnGap === void 0 ? '20px' : _ref2$columnGap;
  return !isObject(columnGap) ? gridColumnGap(columnGap) : mapScalesFn(theme.breakpoints, gridColumnGap, columnGap);
};

var gutterY = function gutterY(_ref3) {
  var theme = _ref3.theme,
      _ref3$rowGap = _ref3.rowGap,
      rowGap = _ref3$rowGap === void 0 ? '20px' : _ref3$rowGap;
  return !isObject(rowGap) ? gridRowGap(rowGap) : mapScalesFn(theme.breakpoints, gridRowGap, rowGap);
};

export var EvenGrid = styled('div').withConfig({
  displayName: "EvenGrid",
  componentId: "sc-rkham4-0"
})(boxSpacer, row, columns, gutterX, gutterY);